module.exports = global.config = {
    // api: ""
    // api: "http://localhost:10053/"
    api: "https://wp-react.webtm.ru"
};